import { SettingOutlined } from "@ant-design/icons";
import { MenuProps } from "antd";
import to from "await-to-js";
import { createContext, useState } from "react";

import { SideLayout } from "../../components/SideLayout/SideLayout";
import IzvestajiOPrometuPage from "../../pages/IzvestajiOPrometuPage/IzvestajiOPrometuPage";
import LoginPage from "../../pages/LoginPage/LoginPage";
import { LoginFailed } from "../../pages/LoginPage/components/LoginFailed/LoginFailed";
import MaintenancePage from "../../pages/MaintenancePage/MaintenancePage";
import { MinistryLicenceDetails } from "../../pages/Ministry/ExciseLicences/MinistryLicencesList/MinistryLicenceDetails/MinistryLicenceDetails";
import { MinistryLicencesList } from "../../pages/Ministry/ExciseLicences/MinistryLicencesList/MinistryLicencesList";
import { MinistryStampsList } from "../../pages/Ministry/ExciseStamps/MinistryStampsList/MinistryStampsList";
import { MinistryUsedStampsList } from "../../pages/Ministry/ExciseStamps/MinistryUsedStampsList/MinistryUsedStampsList";
import { MinistryWarehouseList } from "../../pages/Ministry/ExciseWarehouse/MinistryWarehouseList/MinistryWarehouseList";
import { MinistryWarehouseRequestDetails } from "../../pages/Ministry/ExciseWarehouse/MinistryWarehouseRequestDetails/MinistryWarehouseRequestDetails";
import { ReturnedStampsRecords } from "../../pages/Ministry/ReturnedStampsRecords/ReturnedStampsRecords";
import MonitoringPage from "../../pages/MonitoringPage/MonitoringPage";
import { ChooseCompany } from "../../pages/Obligee/ChooseCompany/ChooseCompany";
import { ExciseLicencesRequestForm } from "../../pages/Obligee/ExciseLicences/ExciseLicencesRequestForm/ExciseLicencesRequestForm";
import { LicenceDetails } from "../../pages/Obligee/ExciseLicences/LicenceDetails/LicenceDetails";
import { AuthorizedPersons } from "../../pages/Obligee/ExciseStamp/AuthorizedPersons/AuthorizedPersons";
import { ExciseWarehouseList } from "../../pages/Obligee/ExciseWarehouse/ExciseWarehouseList/ExciseWarehouseList";
import { ExciseWarehouseRequestLicence } from "../../pages/Obligee/ExciseWarehouse/ExciseWarehouseRequestLicence/ExciseWarehouseRequestLicence";
import { PeriodicReport } from "../../pages/Obligee/StampsRecord/PeriodicReport/PeriodicReport";
import PeriodicReportListPage from "../../pages/Obligee/StampsRecord/PeriodicReport/PeriodicReportList";
import { UsedStampsListPage } from "../../pages/Obligee/StampsRecord/UsedStampsList/UsedStampsList";
import { UsedStampsRecord } from "../../pages/Obligee/StampsRecord/UsedStampsRecord/UsedStampsRecord";
import { ObligeeRegistryPage } from "../../pages/ObligeeRegistryPage/ObligeeRegistryPage";
import { ObligeeRegistryDetails } from "../../pages/ObligeeRegistryPage/components/ObligeeRegistryDetails/ObligeeRegistryDetails";
import ProductionCodeCreationSuccessPage from "../../pages/ProductionCode/ProductionCodeCreationSuccessPage/ProductionCodeCreationSuccessPage";
import ProductionCodeRequestList from "../../pages/ProductionCode/ProductionCodeRequestListPage/ProductionCodeRequestListPage";
import ProductionCodeRequestPage from "../../pages/ProductionCode/ProductionCodeRequestPage/ProductionCodeRequestPage";
import ProdukcioniKodoviListaIzvodaPage from "../../pages/ProductionCode/ProdukcioniKodoviListaIzvodaPage/ProdukcioniKodoviListaIzvodaPage";
import { PuObrasciPage } from "../../pages/PuObrasciPage/PuObrasciPage";
import { PuObrazac } from "../../pages/PuObrasciPage/components/PuObrazac/PuObrazac";
import { RedirectLogin } from "../../pages/RedirectLogin/RedirectLogin";
import { RegisterCompany } from "../../pages/RegisterCompany/RegisterCompany";
import { ResetPasswordPage } from "../../pages/ResetPasswordPage/ResetPasswordPage";
import { SetupCredentialsPage } from "../../pages/ResetPasswordPage/SetupCredentialsPage/SetupCredentialsPage";
import { SettingsPage } from "../../pages/SettingsPage/SettingsPage";
import SuccessPage from "../../pages/SuccessPage/SuccessPage";
import { BrandRegistrationList } from "../../pages/components/CentralRegistry/BrandRegistrationList/BrandRegistrationList";
import { BrandRegistry } from "../../pages/components/CentralRegistry/BrandRegistry/BrandRegistry";
import { MerchantRegistrationList } from "../../pages/components/CentralRegistry/MerchantRegistrationList/MerchantRegistrationList";
import { ObjektiPrivrednihSubjekata } from "../../pages/components/CentralRegistry/ObjektiPrivrednihSubjekata/ObjektiPrivrednihSubjekata";
import { RetailPriceRegistry } from "../../pages/components/CentralRegistry/RetailPriceRegistry/RetailPriceRegistry";
import { SubjectMerchantRegistry } from "../../pages/components/CentralRegistry/SubjectMerchantRegistry/SubjectMerchantRegistry";
import ExciseLicenceRequestList from "../../pages/components/ExciseLicenceRequestList/ExciseLicenceRequestList";
import { ExciseNewRequest } from "../../pages/components/ExciseNewRequest/ExciseNewRequest";
import ExciseStampRequestList from "../../pages/components/ExciseStampRequestList/ExciseStampRequestList";
import { RequestSuccessfullySent } from "../../pages/components/RequestSuccessfullySent/RequestSuccessfullySent";
import { StampDetails } from "../../pages/components/StampDetails/StampDetails";
import { IstorijaPracenja } from "../../pages/components/TrackAndTrace/IstorijaPracenja/IstorijaPracenja";
import TrackingPage from "../../pages/components/TrackAndTrace/Pracenje/TrackingPage";
import { FormMode } from "../../types";
import storage from "../../utils/storage";
import { ROUTE_ACCESS_MAP, RouteSections, UserRoles } from "./auth.constants";
import { authService } from "./auth.service";
import { IRoutes, IUserCompany } from "./auth.types";

const PracenjeObveznik = () => {
  return <TrackingPage />;
};

const PracenjeMfin = () => {
  return <TrackingPage isMfin />;
};

const IstorijaPracenjaObveznik = () => {
  return <IstorijaPracenja />;
};

const IstorijaPracenjaMfin = () => {
  return <IstorijaPracenja type="mfin" />;
};

const ExciseListMarkice = () => {
  return <ExciseStampRequestList />;
};

const StampDetailsObveznik = () => {
  return <StampDetails type="obveznik" />;
};

const StampDetailsMfin = () => {
  return <StampDetails />;
};

const ExciseListDozvole = () => {
  return <ExciseLicenceRequestList />;
};

const ExciseLicencesRequestFormDozvole = () => {
  return <ExciseLicencesRequestForm type="dozvole" />;
};

const RequestSuccessfullySentMarkice = () => {
  return <RequestSuccessfullySent type="markice" />;
};

const SuccessPageWarehouse = () => {
  return <SuccessPage />;
};

const PeriodicReportObveznik = () => {
  return <PeriodicReport />;
};

const PeriodicReportMfin = () => {
  return <PeriodicReport type />;
};

const PeriodicReportListMfin = () => {
  return <PeriodicReportListPage />;
};

const RequestSuccessfullySentDozvola = () => {
  return <RequestSuccessfullySent type="dozvole" />;
};

const RequestSuccessfullySentSkladista = () => {
  return <RequestSuccessfullySent type="skladista" />;
};

const QrCodeListMfin = () => {
  return <ProductionCodeRequestList isMfin />;
};

const QrCodeListObveznik = () => {
  return <ProductionCodeRequestList />;
};

const ProductionCodeRequestPageObveznik = () => {
  return <ProductionCodeRequestPage formMode={FormMode.CREATE} />;
};

const ProductionCodeRequestPageDetailsObveznik = () => {
  return <ProductionCodeRequestPage formMode={FormMode.DETAILS} />;
};

const ProductionCodeRequestPageMfin = () => {
  return <ProductionCodeRequestPage formMode={FormMode.DETAILS} isMfin />;
};

const SubjectMerchantRegistryPosebanPostupak = () => {
  return <SubjectMerchantRegistry type />;
};

const SubjectMerchantRegistryTrgovciVeliko = () => {
  return <SubjectMerchantRegistry />;
};

interface AuthContextState {
  loggedIn: boolean;
  userCompanyList: IUserCompany[];
  allUserRoles: UserRoles[];
  showAddDrustvo: boolean;
  selectedDrustvoId: number | null;
}

export type UpdateAuthStateFunction = (
  updatedState: Partial<AuthContextState>
) => void;

export interface ModalContextProviderProps {
  children: JSX.Element;
}

const initialState = (): AuthContextState => ({
  loggedIn: !!storage.getToken(),
  userCompanyList: [],
  allUserRoles: authService.getRole(),
  showAddDrustvo: authService.getShowAddDrustvo(),
  selectedDrustvoId: null,
});

export const AuthContext = createContext<{
  auth: AuthContextState;
  fetchUserCompanies: () => void;
  setAuth: UpdateAuthStateFunction;
  GET_ROUTES: (userRoles: UserRoles[]) => IRoutes[];
  MenuItemsMinistry: (i18n: any) => MenuProps["items"];
  MenuItemsObligee: (i18n: any) => MenuProps["items"];
  clearAuth: any;
}>(null as any);

export const AuthContextProvider = ({
  children,
}: ModalContextProviderProps) => {
  const [auth, setAuth] = useState(initialState());

  const handleUpdatAauth = (updatedState: Partial<AuthContextState>) => {
    setAuth({ ...auth, ...updatedState });
  };

  const clearAuth = () => {
    setAuth(initialState());
  };

  const setUserCompanies = (userCompanyList: IUserCompany[]) => {
    handleUpdatAauth({ userCompanyList });
    storage.setData("userCompanyList", userCompanyList);
  };

  const fetchUserCompanies = async () => {
    const [err, res] = await to(authService.getUserCompanies());
    if (err || !res.success) return;
    setUserCompanies(res.data);
  };

  const GET_ROUTES: (userRoles: UserRoles[]) => IRoutes[] = (userRoles) => {
    const ROLES_WITH_USER_ACCESS: IRoutes[] = [
      {
        path: "/",
        element: LoginPage,
        canAccess: true,
      },
      { path: "/LogInSuccess", element: RedirectLogin, canAccess: true },
      { path: "/LogInFailed", element: LoginFailed, canAccess: true },
      { path: "/Maintenance", element: MaintenancePage, canAccess: true },
      {
        path: "/obveznik",
        element: SideLayout,
        canAccess: true,
        nestedPaths: [
          {
            path: "podesavanja",
            element: SettingsPage,
            canAccess: true,
          },
          {
            path: "puObrasci",
            element: PuObrasciPage,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.OBVEZNIK_PU_OBRASCI
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "puObrasci/detaljiObrasca",
            element: PuObrazac,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.OBVEZNIK_PU_OBRASCI
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
        ],
      },
      {
        path: "/obveznik/trackAndTrace",
        element: SideLayout,
        canAccess: ROUTE_ACCESS_MAP[RouteSections.OBVEZNIK_TT].read.some(
          (enabledRole) => userRoles.includes(enabledRole)
        ),
        nestedPaths: [
          {
            path: "pracenje",
            element: PracenjeObveznik,
            canAccess: ROUTE_ACCESS_MAP[RouteSections.OBVEZNIK_TT].read.some(
              (enabledRole) => userRoles.includes(enabledRole)
            ),
          },
          {
            path: "istorija",
            element: IstorijaPracenjaObveznik,
            canAccess: ROUTE_ACCESS_MAP[RouteSections.OBVEZNIK_TT].read.some(
              (enabledRole) => userRoles.includes(enabledRole)
            ),
          },
        ],
      },
      {
        path: "/chooseCompany",
        element: ChooseCompany,
        canAccess: true,
      },
      {
        path: "/activateDrustvo",
        element: RegisterCompany,
        canAccess: true,
      },
      {
        path: "/resetPassword",
        element: ResetPasswordPage,
        canAccess: true,
      },
      {
        path: "/setupSuccess",
        element: SetupCredentialsPage,
        canAccess: ROUTE_ACCESS_MAP[
          RouteSections.OBVEZNIK_SKENIRANJE
        ].read.some((enabledRole) => userRoles.includes(enabledRole)),
      },
      {
        path: "/obveznik/akcizneMarkice",
        element: SideLayout,
        canAccess: ROUTE_ACCESS_MAP[RouteSections.OBVEZNIK].read.some(
          (enabledRole) => userRoles.includes(enabledRole)
        ),
        nestedPaths: [
          {
            path: "noviZahtev",
            element: ExciseNewRequest,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.OBVEZNIK_MARKICE
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "listaMarkica",
            element: ExciseListMarkice,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.OBVEZNIK_MARKICE
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "detaljiMarkica",
            element: StampDetailsObveznik,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.OBVEZNIK_MARKICE
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "zahtevPodnet",
            element: RequestSuccessfullySentMarkice,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.OBVEZNIK_MARKICE
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "ovlascenaLica",
            element: AuthorizedPersons,
            canAccess:
              ROUTE_ACCESS_MAP[RouteSections.OBVEZNIK_OVLASCENA_LICA].read.some(
                (enabledRole) => userRoles.includes(enabledRole)
              ) ||
              ROUTE_ACCESS_MAP[RouteSections.OBVEZNIK].read.some(
                (enabledRole) => userRoles.includes(enabledRole)
              ),
          },
          {
            path: "evidencijaIskoriscenihMarkica",
            element: UsedStampsRecord,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.OBVEZNIK_PERIODICNI_IZVESTAJ
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "listaIskoriscenihMarkica",
            element: UsedStampsListPage,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.OBVEZNIK_PERIODICNI_IZVESTAJ
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "periodicniIzvestaji",
            element: PeriodicReportObveznik,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.OBVEZNIK_PERIODICNI_IZVESTAJ
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
        ],
      },
      {
        path: "/obveznik/akcizneDozvole",
        element: SideLayout,
        canAccess: ROUTE_ACCESS_MAP[RouteSections.OBVEZNIK_DOZVOLE].read.some(
          (enabledRole) => userRoles.includes(enabledRole)
        ),
        nestedPaths: [
          {
            path: "noviZahtev",
            element: ExciseLicencesRequestFormDozvole,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.OBVEZNIK_DOZVOLE
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "listaDozvola",
            element: ExciseListDozvole,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.OBVEZNIK_DOZVOLE
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "detaljiDozvola",
            element: LicenceDetails,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.OBVEZNIK_DOZVOLE
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "zahtevPodnet",
            element: RequestSuccessfullySentDozvola,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.OBVEZNIK_DOZVOLE
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
        ],
      },
      {
        path: "/obveznik/produkcioniKodovi",
        element: SideLayout,
        canAccess: ROUTE_ACCESS_MAP[
          RouteSections.OBVEZNIK_PRODUKCIONI_KODOVI
        ].read.some((enabledRole) => userRoles.includes(enabledRole)),
        nestedPaths: [
          {
            path: "noviZahtev",
            element: ProductionCodeRequestPageObveznik,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.OBVEZNIK_PRODUKCIONI_KODOVI
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "listaProdukcionihKodova",
            element: QrCodeListObveznik,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.OBVEZNIK_PRODUKCIONI_KODOVI
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "pregledZahteva",
            element: ProductionCodeRequestPageDetailsObveznik,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.OBVEZNIK_PRODUKCIONI_KODOVI
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "uspesnoKreiranjeZahteva",
            element: ProductionCodeCreationSuccessPage,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.OBVEZNIK_PRODUKCIONI_KODOVI
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
        ],
      },
      {
        path: "/obveznik/skladista",
        element: SideLayout,
        canAccess: ROUTE_ACCESS_MAP[RouteSections.OBVEZNIK_DOZVOLE].read.some(
          (enabledRole) => userRoles.includes(enabledRole)
        ),
        nestedPaths: [
          {
            path: "listaSkladista",
            element: ExciseWarehouseList,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.OBVEZNIK_DOZVOLE
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "zahtev",
            element: ExciseWarehouseRequestLicence,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.OBVEZNIK_DOZVOLE
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "zahtevPodnet",
            element: RequestSuccessfullySentSkladista,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.OBVEZNIK_DOZVOLE
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "zahtevUspesan",
            element: SuccessPageWarehouse,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.OBVEZNIK_DOZVOLE
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
        ],
      },
      {
        path: "/mfin",
        element: SideLayout,
        canAccess: true,
        nestedPaths: [
          {
            path: "listaMarkica",
            element: MinistryStampsList,
            canAccess: ROUTE_ACCESS_MAP[RouteSections.MFIN_MARKICE].read.some(
              (enabledRole) => userRoles.includes(enabledRole)
            ),
          },
          {
            path: "listaEvidentiranihMarkica",
            element: MinistryUsedStampsList,
            canAccess: ROUTE_ACCESS_MAP[RouteSections.MFIN_MARKICE].read.some(
              (enabledRole) => userRoles.includes(enabledRole)
            ),
          },
          {
            path: "evidencijaVracenihMarkica",
            element: ReturnedStampsRecords,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.MFIN_EVIDENCIJA_VRACENIH
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "listaDozvola",
            element: MinistryLicencesList,
            canAccess: ROUTE_ACCESS_MAP[RouteSections.MFIN_DOZVOLE].read.some(
              (enabledRole) => userRoles.includes(enabledRole)
            ),
          },
          {
            path: "listaSkladista",
            element: MinistryWarehouseList,
            canAccess: ROUTE_ACCESS_MAP[RouteSections.MFIN_DOZVOLE].read.some(
              (enabledRole) => userRoles.includes(enabledRole)
            ),
          },
          {
            path: "puObrasci",
            element: PuObrasciPage,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.MFIN_PU_OBRASCI
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "puObrasci/detaljiObrasca",
            element: PuObrazac,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.MFIN_PU_OBRASCI
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "podesavanja",
            element: SettingsPage,
            canAccess: ROUTE_ACCESS_MAP[RouteSections.MFIN].read.some(
              (enabledRole) => userRoles.includes(enabledRole)
            ),
          },
        ],
      },
      {
        path: "/mfin/periodicniIzvestaji",
        element: SideLayout,
        canAccess: ROUTE_ACCESS_MAP[
          RouteSections.MFIN_PERIODICNI_IZVESTAJ
        ].read.some((enabledRole) => userRoles.includes(enabledRole)),
        nestedPaths: [
          {
            path: "detalji",
            element: PeriodicReportMfin,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.MFIN_PERIODICNI_IZVESTAJ
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "lista",
            element: PeriodicReportListMfin,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.MFIN_PERIODICNI_IZVESTAJ
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
        ],
      },
      {
        path: "/mfin/produkcioniKodovi",
        element: SideLayout,
        canAccess: true,
        nestedPaths: [
          {
            path: "lista",
            element: QrCodeListMfin,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.MFIN_PRODUKCIONI_KODOVI
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "listaIzvoda",
            element: ProdukcioniKodoviListaIzvodaPage,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.MFIN_PRODUKCIONI_KODOVI
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "pregledZahteva",
            element: ProductionCodeRequestPageMfin,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.MFIN_PRODUKCIONI_KODOVI
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
        ],
      },
      {
        path: "/mfin/centralniRegistar",
        element: SideLayout,
        canAccess: ROUTE_ACCESS_MAP[
          RouteSections.MFIN_REGISTRI_PREGLED
        ].read.some((enabledRole) => userRoles.includes(enabledRole)),
        nestedPaths: [
          {
            path: "registri",
            element: ObligeeRegistryPage,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.MFIN_REGISTRI_PREGLED
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "registri/detaljiObveznika",
            element: ObligeeRegistryDetails,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.MFIN_REGISTRI_PREGLED
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "registarOMarkama",
            element: BrandRegistry,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.MFIN_REGISTRI_PREGLED
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "maloprodajneCene",
            element: RetailPriceRegistry,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.MFIN_REGISTRI_PREGLED
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "evidencionaListaMarka",
            element: BrandRegistrationList,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.MFIN_REGISTRI_PREGLED
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "evidencionaListaTrgovci",
            element: MerchantRegistrationList,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.MFIN_REGISTRI_PREGLED
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "registarSubjekata",
            element: SubjectMerchantRegistryPosebanPostupak,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.MFIN_REGISTRI_PREGLED
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "registarTrgovaca",
            element: SubjectMerchantRegistryTrgovciVeliko,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.MFIN_REGISTRI_PREGLED
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
          {
            path: "objektiPrivrednihSubjekata",
            element: ObjektiPrivrednihSubjekata,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.MFIN_REGISTRI_PREGLED
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
        ],
      },
      {
        path: "/mfin/trackAndTrace",
        element: SideLayout,
        canAccess:
          ROUTE_ACCESS_MAP[RouteSections.MFIN_TT].read.some((enabledRole) =>
            userRoles.includes(enabledRole)
          ) ||
          ROUTE_ACCESS_MAP[RouteSections.MFIN_TT_IZVESTAJ_PROMET].read.some(
            (enabledRole) => userRoles.includes(enabledRole)
          ),
        nestedPaths: [
          {
            path: "pracenje",
            element: PracenjeMfin,
            canAccess: ROUTE_ACCESS_MAP[RouteSections.MFIN_TT].read.some(
              (enabledRole) => userRoles.includes(enabledRole)
            ),
          },
          {
            path: "istorija",
            element: IstorijaPracenjaMfin,
            canAccess: ROUTE_ACCESS_MAP[RouteSections.MFIN_TT].read.some(
              (enabledRole) => userRoles.includes(enabledRole)
            ),
          },
          {
            path: "monitoring",
            element: MonitoringPage,
            canAccess: ROUTE_ACCESS_MAP[RouteSections.MFIN_TT].read.some(
              (enabledRole) => userRoles.includes(enabledRole)
            ),
          },
          {
            path: "izvestajiOPrometu",
            element: IzvestajiOPrometuPage,
            canAccess: ROUTE_ACCESS_MAP[
              RouteSections.MFIN_TT_IZVESTAJ_PROMET
            ].read.some((enabledRole) => userRoles.includes(enabledRole)),
          },
        ],
      },
      {
        path: "/mfin/listaMarkica",
        element: SideLayout,
        canAccess: ROUTE_ACCESS_MAP[RouteSections.MFIN_MARKICE].read.some(
          (enabledRole) => userRoles.includes(enabledRole)
        ),
        nestedPaths: [
          {
            path: "detaljiMarkica",
            element: StampDetailsMfin,
            canAccess: ROUTE_ACCESS_MAP[RouteSections.MFIN_MARKICE].read.some(
              (enabledRole) => userRoles.includes(enabledRole)
            ),
          },
        ],
      },
      {
        path: "/mfin/listaDozvola",
        element: SideLayout,
        canAccess: ROUTE_ACCESS_MAP[RouteSections.MFIN_DOZVOLE].read.some(
          (enabledRole) => userRoles.includes(enabledRole)
        ),
        nestedPaths: [
          {
            path: "zahtev",
            element: MinistryLicenceDetails,
            canAccess: ROUTE_ACCESS_MAP[RouteSections.MFIN_DOZVOLE].read.some(
              (enabledRole) => userRoles.includes(enabledRole)
            ),
          },
        ],
      },
      {
        path: "/mfin/listaSkladista",
        element: SideLayout,
        canAccess: ROUTE_ACCESS_MAP[RouteSections.MFIN_DOZVOLE].read.some(
          (enabledRole) => userRoles.includes(enabledRole)
        ),
        nestedPaths: [
          {
            path: "zahtev",
            element: MinistryWarehouseRequestDetails,
            canAccess: ROUTE_ACCESS_MAP[RouteSections.MFIN_DOZVOLE].read.some(
              (enabledRole) => userRoles.includes(enabledRole)
            ),
          },
        ],
      },
    ];
    const AVAILABLE_ROLES = ROLES_WITH_USER_ACCESS.filter(
      (role) => role.canAccess
    );

    const routeAccessReducer = (acc: IRoutes[], route: IRoutes) => {
      if (route.nestedPaths) {
        route.nestedPaths = route.nestedPaths.filter(
          (route) => route.canAccess
        );
      }
      return route.canAccess ? [...acc, route] : acc;
    };

    return AVAILABLE_ROLES.reduce(routeAccessReducer, []);
  };

  const MenuItemsMinistry = (i18n: any) => [
    {
      label: i18n.t("NAVIGATION.AKCIZNE_MARKICE"),
      key: "/mfin/akcizneMarkice",
      icon: <SettingOutlined />,
      isVisible: ROUTE_ACCESS_MAP[RouteSections.MFIN_MARKICE].read.some(
        (enabledRole) => auth.allUserRoles.includes(enabledRole)
      ),
      children: [
        {
          type: "group",
          isVisible: ROUTE_ACCESS_MAP[RouteSections.MFIN_MARKICE].read.some(
            (enabledRole) => auth.allUserRoles.includes(enabledRole)
          ),
          children: [
            {
              label: i18n.t("NAVIGATION.LISTA_ZAHTEVA"),
              key: "/mfin/listaMarkica",
              isVisible: ROUTE_ACCESS_MAP[RouteSections.MFIN_MARKICE].read.some(
                (enabledRole) => auth.allUserRoles.includes(enabledRole)
              ),
            },
            {
              label: i18n.t("NAVIGATION.LISTA_EVIDENTIRANIH_MARKICA"),
              key: "/mfin/listaEvidentiranihMarkica",
              isVisible: ROUTE_ACCESS_MAP[RouteSections.MFIN_MARKICE].read.some(
                (enabledRole) => auth.allUserRoles.includes(enabledRole)
              ),
            },
          ],
        },
      ],
    },
    {
      label: i18n.t("NAVIGATION.AKCIZNE_DOZVOLE"),
      key: "/mfin/listaDozvola",
      icon: <SettingOutlined />,
      isVisible: ROUTE_ACCESS_MAP[RouteSections.MFIN_DOZVOLE].read.some(
        (enabledRole) => auth.allUserRoles.includes(enabledRole)
      ),
    },
    {
      label: i18n.t("NAVIGATION.AKCIZNA_SKLADISTA"),
      key: "/mfin/listaSkladista",
      icon: <SettingOutlined />,
      isVisible: ROUTE_ACCESS_MAP[RouteSections.MFIN_DOZVOLE].read.some(
        (enabledRole) => auth.allUserRoles.includes(enabledRole)
      ),
    },
    {
      label: i18n.t("NAVIGATION.EVIDENCIJA_VRACENIH_MARKICA"),
      key: "/mfin/evidencijaVracenihMarkica",
      icon: <SettingOutlined />,
      isVisible: ROUTE_ACCESS_MAP[
        RouteSections.MFIN_EVIDENCIJA_VRACENIH
      ].read.some((enabledRole) => auth.allUserRoles.includes(enabledRole)),
    },
    {
      label: i18n.t("NAVIGATION.QR"),
      key: "/mfin/produkcioniKodovi",
      icon: <SettingOutlined />,
      isVisible: ROUTE_ACCESS_MAP[
        RouteSections.MFIN_PRODUKCIONI_KODOVI
      ].read.some((enabledRole) => auth.allUserRoles.includes(enabledRole)),
      children: [
        {
          type: "group",
          isVisible: ROUTE_ACCESS_MAP[
            RouteSections.MFIN_PRODUKCIONI_KODOVI
          ].read.some((enabledRole) => auth.allUserRoles.includes(enabledRole)),
          children: [
            {
              label: i18n.t("NAVIGATION.LISTA_ZAHTEVA"),
              key: "/mfin/produkcioniKodovi/lista",
              isVisible: ROUTE_ACCESS_MAP[
                RouteSections.MFIN_PRODUKCIONI_KODOVI
              ].read.some((enabledRole) =>
                auth.allUserRoles.includes(enabledRole)
              ),
            },
            {
              label: i18n.t("NAVIGATION.LISTA_IZVODA"),
              key: "/mfin/produkcioniKodovi/listaIzvoda",
              isVisible: ROUTE_ACCESS_MAP[
                RouteSections.MFIN_PRODUKCIONI_KODOVI
              ].read.some((enabledRole) =>
                auth.allUserRoles.includes(enabledRole)
              ),
            },
          ],
        },
      ],
    },
    {
      label: i18n.t("NAVIGATION.PERIODICNI_IZVESTAJI"),
      key: "/mfin/periodicniIzvestaji",
      icon: <SettingOutlined />,
      isVisible: ROUTE_ACCESS_MAP[
        RouteSections.MFIN_PERIODICNI_IZVESTAJ
      ].read.some((enabledRole) => auth.allUserRoles.includes(enabledRole)),
      children: [
        {
          type: "group",
          isVisible: ROUTE_ACCESS_MAP[
            RouteSections.MFIN_PERIODICNI_IZVESTAJ
          ].read.some((enabledRole) => auth.allUserRoles.includes(enabledRole)),
          children: [
            {
              label: i18n.t("NAVIGATION.DETALJI_PERIODICNOG_IZVESTAJA"),
              key: "/mfin/periodicniIzvestaji/detalji",
              isVisible: ROUTE_ACCESS_MAP[
                RouteSections.MFIN_PERIODICNI_IZVESTAJ
              ].read.some((enabledRole) =>
                auth.allUserRoles.includes(enabledRole)
              ),
            },
            {
              label: i18n.t("NAVIGATION.LISTA_PERIODICNIH_IZVESTAJA"),
              key: "/mfin/periodicniIzvestaji/lista",
              isVisible: ROUTE_ACCESS_MAP[
                RouteSections.MFIN_PERIODICNI_IZVESTAJ
              ].read.some((enabledRole) =>
                auth.allUserRoles.includes(enabledRole)
              ),
            },
          ],
        },
      ],
    },
    {
      label: i18n.t("NAVIGATION.PODACI_O_IZVRSENOM_UVOZU"),
      key: "/mfin/puObrasci",
      icon: <SettingOutlined />,
      isVisible: ROUTE_ACCESS_MAP[RouteSections.MFIN_PU_OBRASCI].read.some(
        (enabledRole) => auth.allUserRoles.includes(enabledRole)
      ),
    },
    {
      label: i18n.t("NAVIGATION.CENTRALNI_REGISTAR"),
      key: "/mfin/centralniRegistar",
      icon: <SettingOutlined />,
      isVisible: ROUTE_ACCESS_MAP[
        RouteSections.MFIN_REGISTRI_PREGLED
      ].read.some((enabledRole) => auth.allUserRoles.includes(enabledRole)),
      children: [
        {
          type: "group",
          isVisible: ROUTE_ACCESS_MAP[
            RouteSections.MFIN_REGISTRI_PREGLED
          ].read.some((enabledRole) => auth.allUserRoles.includes(enabledRole)),
          children: [
            {
              label: i18n.t("NAVIGATION.REGISTAR_OBVEZNIKA"),
              key: "/mfin/centralniRegistar/registri",
              isVisible: ROUTE_ACCESS_MAP[
                RouteSections.MFIN_REGISTRI_PREGLED
              ].read.some((enabledRole) =>
                auth.allUserRoles.includes(enabledRole)
              ),
            },
            {
              label: i18n.t("NAVIGATION.REGISTAR_O_MARKAMA_S"),
              key: "/mfin/centralniRegistar/registarOMarkama",
              isVisible: ROUTE_ACCESS_MAP[
                RouteSections.MFIN_REGISTRI_PREGLED
              ].read.some((enabledRole) =>
                auth.allUserRoles.includes(enabledRole)
              ),
            },
            {
              label: i18n.t("NAVIGATION.MALOPRODAJNE_CENE"),
              key: "/mfin/centralniRegistar/maloprodajneCene",
              isVisible: ROUTE_ACCESS_MAP[
                RouteSections.MFIN_REGISTRI_PREGLED
              ].read.some((enabledRole) =>
                auth.allUserRoles.includes(enabledRole)
              ),
            },
            {
              label: i18n.t("NAVIGATION.DUVANSKI_PROIZVODI_PP"),
              key: "/mfin/centralniRegistar/evidencionaListaMarka",
              isVisible: ROUTE_ACCESS_MAP[
                RouteSections.MFIN_REGISTRI_PREGLED
              ].read.some((enabledRole) =>
                auth.allUserRoles.includes(enabledRole)
              ),
            },
            {
              label: i18n.t("NAVIGATION.EVIDENCIONA_LISTA_TRGOVCIMA"),
              key: "/mfin/centralniRegistar/evidencionaListaTrgovci",
              isVisible: ROUTE_ACCESS_MAP[
                RouteSections.MFIN_REGISTRI_PREGLED
              ].read.some((enabledRole) =>
                auth.allUserRoles.includes(enabledRole)
              ),
            },
            {
              label: i18n.t("NAVIGATION.REGISTAR_SUBJEKATA_CELO"),
              key: "/mfin/centralniRegistar/registarSubjekata",
              isVisible: ROUTE_ACCESS_MAP[
                RouteSections.MFIN_REGISTRI_PREGLED
              ].read.some((enabledRole) =>
                auth.allUserRoles.includes(enabledRole)
              ),
            },
            {
              label: i18n.t("NAVIGATION.REGISTAR_TRGOVACA_S"),
              key: "/mfin/centralniRegistar/registarTrgovaca",
              isVisible: ROUTE_ACCESS_MAP[
                RouteSections.MFIN_REGISTRI_PREGLED
              ].read.some((enabledRole) =>
                auth.allUserRoles.includes(enabledRole)
              ),
            },
            {
              label: i18n.t("NAVIGATION.OBJEKTI_PRIVREDNIH_SUBJEKATA"),
              key: "/mfin/centralniRegistar/objektiPrivrednihSubjekata",
              isVisible: ROUTE_ACCESS_MAP[
                RouteSections.MFIN_REGISTRI_PREGLED
              ].read.some((enabledRole) =>
                auth.allUserRoles.includes(enabledRole)
              ),
            },
          ],
        },
      ],
    },
    {
      label: "Track & trace",
      key: "/mfin/trackAndTrace",
      icon: <SettingOutlined />,
      isVisible:
        ROUTE_ACCESS_MAP[RouteSections.MFIN_TT].read.some((enabledRole) =>
          auth.allUserRoles.includes(enabledRole)
        ) ||
        ROUTE_ACCESS_MAP[RouteSections.MFIN_TT_IZVESTAJ_PROMET].read.some(
          (enabledRole) => auth.allUserRoles.includes(enabledRole)
        ),
      children: [
        {
          type: "group",
          isVisible:
            ROUTE_ACCESS_MAP[RouteSections.MFIN_TT].read.some((enabledRole) =>
              auth.allUserRoles.includes(enabledRole)
            ) ||
            ROUTE_ACCESS_MAP[RouteSections.MFIN_TT_IZVESTAJ_PROMET].read.some(
              (enabledRole) => auth.allUserRoles.includes(enabledRole)
            ),
          children: [
            {
              label: i18n.t("TRACK.PRACENJE"),
              key: "/mfin/trackAndTrace/pracenje",
              isVisible: ROUTE_ACCESS_MAP[RouteSections.MFIN_TT].read.some(
                (enabledRole) => auth.allUserRoles.includes(enabledRole)
              ),
            },
            {
              label: i18n.t("TRACK.ISTORIJA"),
              key: "/mfin/trackAndTrace/istorija",
              isVisible: ROUTE_ACCESS_MAP[RouteSections.MFIN_TT].read.some(
                (enabledRole) => auth.allUserRoles.includes(enabledRole)
              ),
            },
            {
              label: i18n.t("TRACK.MONITORING"),
              key: "/mfin/trackAndTrace/monitoring",
              isVisible: ROUTE_ACCESS_MAP[RouteSections.MFIN_TT].read.some(
                (enabledRole) => auth.allUserRoles.includes(enabledRole)
              ),
            },
            {
              label: i18n.t("TRACK.IZVESTAJI_O_PROMETU"),
              key: "/mfin/trackAndTrace/izvestajiOPrometu",
              isVisible: ROUTE_ACCESS_MAP[
                RouteSections.MFIN_TT_IZVESTAJ_PROMET
              ].read.some((enabledRole) =>
                auth.allUserRoles.includes(enabledRole)
              ),
            },
          ],
        },
      ],
    },
    {
      label: i18n.t("NAVIGATION.PODESAVANJA"),
      key: "/mfin/podesavanja",
      icon: <SettingOutlined />,
      isVisible: true,
    },
  ];

  const MenuItemsObligee = (i18n: any) => [
    {
      label: i18n.t("NAVIGATION.AKCIZNE_MARKICE"),
      key: "akcizneMarkice",
      icon: <SettingOutlined />,
      isVisible:
        ROUTE_ACCESS_MAP[RouteSections.OBVEZNIK_MARKICE].read.some(
          (enabledRole) => auth.allUserRoles.includes(enabledRole)
        ) ||
        ROUTE_ACCESS_MAP[RouteSections.OBVEZNIK_OVLASCENA_LICA].read.some(
          (enabledRole) => auth.allUserRoles.includes(enabledRole)
        ) ||
        ROUTE_ACCESS_MAP[RouteSections.OBVEZNIK_PERIODICNI_IZVESTAJ].read.some(
          (enabledRole) => auth.allUserRoles.includes(enabledRole)
        ),
      children: [
        {
          label: i18n.t("NAVIGATION.NOVI_ZAHTEV"),
          key: "/obveznik/akcizneMarkice/noviZahtev",
          isVisible: ROUTE_ACCESS_MAP[RouteSections.OBVEZNIK_MARKICE].read.some(
            (enabledRole) => auth.allUserRoles.includes(enabledRole)
          ),
        },
        {
          label: i18n.t("NAVIGATION.LISTA_ZAHTEVA"),
          key: "/obveznik/akcizneMarkice/listaMarkica",
          isVisible: ROUTE_ACCESS_MAP[RouteSections.OBVEZNIK_MARKICE].read.some(
            (enabledRole) => auth.allUserRoles.includes(enabledRole)
          ),
        },
        {
          label: i18n.t("NAVIGATION.OVLASCENA_LICA"),
          key: "/obveznik/akcizneMarkice/ovlascenaLica",
          isVisible: ROUTE_ACCESS_MAP[
            RouteSections.OBVEZNIK_OVLASCENA_LICA
          ].read.some((enabledRole) => auth.allUserRoles.includes(enabledRole)),
        },
        {
          label: i18n.t("NAVIGATION.EVIDENCIJA_ISPORUCENIH_MARKICA"),
          key: "/obveznik/akcizneMarkice/evidencijaIskoriscenihMarkica",
          isVisible: ROUTE_ACCESS_MAP[
            RouteSections.OBVEZNIK_PERIODICNI_IZVESTAJ
          ].read.some((enabledRole) => auth.allUserRoles.includes(enabledRole)),
        },
        {
          label: i18n.t("NAVIGATION.LISTA_EVIDENTIRANIH_MARKICA"),
          key: "/obveznik/akcizneMarkice/listaIskoriscenihMarkica",
          isVisible: ROUTE_ACCESS_MAP[
            RouteSections.OBVEZNIK_PERIODICNI_IZVESTAJ
          ].read.some((enabledRole) => auth.allUserRoles.includes(enabledRole)),
        },
        {
          label: i18n.t("NAVIGATION.PERIODICNI_IZVESTAJI"),
          key: "/obveznik/akcizneMarkice/periodicniIzvestaji",
          isVisible: ROUTE_ACCESS_MAP[
            RouteSections.OBVEZNIK_PERIODICNI_IZVESTAJ
          ].read.some((enabledRole) => auth.allUserRoles.includes(enabledRole)),
        },
      ],
    },
    {
      label: i18n.t("NAVIGATION.AKCIZNE_DOZVOLE"),
      key: "akcizneDozvole",
      icon: <SettingOutlined />,
      isVisible: ROUTE_ACCESS_MAP[RouteSections.OBVEZNIK_DOZVOLE].read.some(
        (enabledRole) => auth.allUserRoles.includes(enabledRole)
      ),
      children: [
        {
          type: "group",
          isVisible: true,
          children: [
            {
              label: i18n.t("NAVIGATION.NOVI_ZAHTEV"),
              key: "/obveznik/akcizneDozvole/noviZahtev",
              isVisible: true,
            },
            {
              label: i18n.t("NAVIGATION.LISTA_ZAHTEVA"),
              key: "/obveznik/akcizneDozvole/listaDozvola",
              isVisible: true,
            },
          ],
        },
      ],
    },
    {
      label: i18n.t("NAVIGATION.AKCIZNA_SKLADISTA"),
      key: "/obveznik/skladista/listaSkladista",
      icon: <SettingOutlined />,
      isVisible: ROUTE_ACCESS_MAP[RouteSections.OBVEZNIK_DOZVOLE].read.some(
        (enabledRole) => auth.allUserRoles.includes(enabledRole)
      ),
    },
    {
      label: i18n.t("NAVIGATION.QR"),
      key: "produkcionihKodova",
      icon: <SettingOutlined />,
      isVisible: ROUTE_ACCESS_MAP[
        RouteSections.OBVEZNIK_PRODUKCIONI_KODOVI
      ].read.some((enabledRole) => auth.allUserRoles.includes(enabledRole)),
      children: [
        {
          type: "group",
          isVisible: true,
          children: [
            {
              label: i18n.t("NAVIGATION.NOVI_ZAHTEV"),
              key: "/obveznik/produkcioniKodovi/noviZahtev",
              isVisible: true,
            },
            {
              label: i18n.t("NAVIGATION.LISTA_ZAHTEVA"),
              key: "/obveznik/produkcioniKodovi/listaProdukcionihKodova",
              isVisible: true,
            },
          ],
        },
      ],
    },
    {
      label: i18n.t("NAVIGATION.PODACI_O_IZVRSENOM_UVOZU"),
      key: "/obveznik/puObrasci",
      icon: <SettingOutlined />,
      isVisible: ROUTE_ACCESS_MAP[RouteSections.OBVEZNIK_PU_OBRASCI].read.some(
        (enabledRole) => auth.allUserRoles.includes(enabledRole)
      ),
    },
    {
      label: "Track & trace",
      key: "/obveznik/trackAndTrace",
      icon: <SettingOutlined />,
      isVisible: ROUTE_ACCESS_MAP[RouteSections.OBVEZNIK_TT].read.some(
        (enabledRole) => auth.allUserRoles.includes(enabledRole)
      ),
      children: [
        {
          type: "group",
          isVisible: true,
          children: [
            {
              label: i18n.t("TRACK.PRACENJE"),
              key: "/obveznik/trackAndTrace/pracenje",
              isVisible: true,
            },
            {
              label: i18n.t("TRACK.ISTORIJA"),
              key: "/obveznik/trackAndTrace/istorija",
              isVisible: true,
            },
          ],
        },
      ],
    },
    {
      label: i18n.t("NAVIGATION.PODESAVANJA"),
      key: "/obveznik/podesavanja",
      icon: <SettingOutlined />,
      isVisible: true,
    },
  ];

  return (
    <AuthContext.Provider
      value={{
        auth,
        setAuth: handleUpdatAauth,
        clearAuth,
        fetchUserCompanies,
        GET_ROUTES,
        MenuItemsObligee,
        MenuItemsMinistry,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
